import QueryError from './QueryError';

export default QueryError;
